import React, { useState, useEffect } from 'react';
import styles from '../styles/wizards/AddForeignEditorsWizard.scss';
import { __, getActiveStage, validateForm } from '../core/utils';
import AddTeamIcon from '../assets/images/add-team-60x60.svg';
import { setNotification } from '../redux/actions/general/notification';
import {
  createSpecificationSetForeignEditors,
  listPossibleSpecificationSetForeignEditors,
  readSpecificationSet,
} from '../redux/actions/table/specification_sets';
import { connect } from 'react-redux';
import AddForeignEditorsForm from '../forms/add_foreign_editors_wizard/AddForeignEditorsForm';

const AddForeignEditorsWizard = (props) => {
  const [possible_foreign_editors, set_possible_foreign_editors] = useState([]);

  const _handleSubmit = (formData) => {
    const specification_set_id = props.table.flyout.id;
    const { edit } = formData;

    formData = {
      ..._.omit(formData, ['edit']),
      foreign_editors: _.map(formData.foreign_editors, ({ id }) => ({
        user_id: id,
        company_id: _.get(
          _.find(possible_foreign_editors, { id }),
          'company_id'
        ),
      })),
    };

    return validateForm(
      createSpecificationSetForeignEditors(specification_set_id, formData).then(
        () => {
          readSpecificationSet(specification_set_id);

          props.onClose();

          setNotification(__('wizard.add-foreign-editor.message.success'));
        }
      )
    );
  };

  useEffect(() => {
    listPossibleSpecificationSetForeignEditors(getActiveStage()).then(
      ({ response }) => {
        set_possible_foreign_editors(response.data);
      }
    );
  }, []);

  const { foreign_editors } = props.table.flyout;

  return (
    <>
      <div className={styles.header}>
        <div className={styles.left}>
          <span>
            {__('wizard.specification-sets.title.add-foreign-editor')}
          </span>
          <span>
            {__('wizard.specification-sets.subtitle.add-foreign-editor')}
          </span>
        </div>
        <div className={styles.right}>
          <AddTeamIcon />
        </div>
      </div>
      <div className={styles.body}>
        <AddForeignEditorsForm
          onSubmit={_handleSubmit}
          initialValues={{
            foreign_editors,
          }}
          possibleForeignEditors={possible_foreign_editors}
        />
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    table: state.table['specification_sets'],
  };
};

export default connect(mapStateToProps, null)(AddForeignEditorsWizard);
